import { create } from 'zustand';
import client from '../api/client';

const STORAGE_KEY = 'guest_exercises_done';

const useGuestStore = create((set, get) => ({
  exercisesDone: parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10),
  limit: 100,

  fetchLimit: async () => {
    try {
      const { data } = await client.get('/config/guest');
      set({ limit: data.exercise_limit });
    } catch {}
  },

  increment: () => {
    const done = get().exercisesDone + 1;
    localStorage.setItem(STORAGE_KEY, String(done));
    set({ exercisesDone: done });
  },

  isLimitReached: () => {
    const { exercisesDone, limit } = get();
    return exercisesDone >= limit;
  },

  remaining: () => {
    const { exercisesDone, limit } = get();
    return Math.max(0, limit - exercisesDone);
  },
}));

export default useGuestStore;
